import { useTranslation } from "react-i18next";

import Text from "../../components/ui/Text";

export default function TokenExpired() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-1 justify-center p-6">
      <Text className="whitespace-pre-line text-center text-[17px] font-medium leading-[22px] text-black6">
        {t("tokenExpired")}
      </Text>
    </div>
  );
}
